import script from "./AtomStatDifferenceIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./AtomStatDifferenceIndicator.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__